export const FaviconDirective = angular
    .module('checkout.directives.favicon', [])
    .directive('favicon', ($window) => {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                faviconUrl: '<'
            },
            link: (scope) => {
                const getFaviconLink = () => $window.document.querySelector('link[rel="shortcut icon"]');

                const setFaviconImage = (imageUrl) => {
                    const faviconLinkElement = getFaviconLink();
                    if (faviconLinkElement && faviconLinkElement.length > 0) {
                        faviconLinkElement.setAttribute('href', imageUrl);
                    } else {
                        $window.document.getElementsByTagName('head')[0]
                            .insertAdjacentHTML(
                                'afterBegin', `<link rel="shortcut icon" type="image/png" href="${imageUrl}" />`);
                    }
                };

                scope.$watch('faviconUrl', (newValue, oldValue) => {
                    if (newValue && newValue !== oldValue) {
                        setFaviconImage(newValue);
                    }
                });
            }
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/directives/favicon.js